(function() {
  var stateKey = '__foreverStorybooksFroonzeWishlistCards';
  var state = window[stateKey] || {
    bound: false,
    attempts: 0,
    retryTimer: null,
    nextSlotId: 0
  };

  window[stateKey] = state;

  var cardSlotSelector = '.book-card__wishlist--content .book-card__wishlist-slot[data-product-handle]';
  var heroSlotSelector = '.product-hero__wishlist-slot[data-product-handle]';
  var slotSelector = cardSlotSelector + ', ' + heroSlotSelector;
  var maxAttempts = 20;
  var retryInterval = 250;

  function getSlots() {
    return document.querySelectorAll(slotSelector);
  }

  function hasSlots() {
    return getSlots().length > 0;
  }

  function isFroonzeReady() {
    return Boolean(
      window.frcp &&
      window.frcp.wishlist &&
      window.frcp.wishlist.initialized &&
      typeof window.frcp.wishlist.attachProductBtnAtPlaceholder === 'function'
    );
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/["\\]/g, '\\$&');
  }

  function getSlotSelector(slot) {
    if (!slot.dataset.froonzePlaceholderId) {
      state.nextSlotId += 1;
      slot.dataset.froonzePlaceholderId = String(state.nextSlotId);
    }

    var baseSelector = slot.classList.contains('product-hero__wishlist-slot')
      ? '.product-hero__wishlist-slot'
      : '.book-card__wishlist--content .book-card__wishlist-slot';

    return (
      baseSelector +
      '[data-froonze-placeholder-id="' +
      cssEscape(slot.dataset.froonzePlaceholderId) +
      '"]'
    );
  }

  function hasFroonzeButton(slot) {
    return Boolean(slot.querySelector('.frcp-wishlist-wrapper') || slot.firstElementChild);
  }

  function getSlotProductData(slot) {
    var card = slot.closest('.book-card');
    var hero = slot.closest('.product-hero');
    var source = card || hero;

    var handle = slot.dataset.productHandle || (source ? source.dataset.productHandle : '');
    var productId = slot.dataset.productId || (source ? source.dataset.productId : '');
    var variantId = slot.dataset.variantId || (source ? source.dataset.variantId : '');
    var titleEl = card
      ? card.querySelector('.book-card__title')
      : hero
        ? hero.querySelector('.product-hero__title')
        : null;
    var title = titleEl ? titleEl.innerText.trim() : '';

    return {
      handle: handle,
      productId: productId,
      variantId: variantId,
      title: title
    };
  }

  function attachSlot(slot) {
    var productData = getSlotProductData(slot);

    if (!productData.handle || !productData.productId || !productData.variantId) return;
    if (slot.dataset.froonzeAttached === 'true') return;
    if (hasFroonzeButton(slot)) return;

    try {
      window.frcp.wishlist.attachProductBtnAtPlaceholder(
        getSlotSelector(slot),
        productData.handle,
        productData.productId,
        productData.variantId,
        'append',
        productData.title
      );

      slot.dataset.froonzeAttached = 'true';
    } catch (error) {
      delete slot.dataset.froonzeAttached;
    }
  }

  function attachWishlistButtons() {
    getSlots().forEach(attachSlot);
  }

  function attachFroonzeCollectionWishlist() {
    if (!hasSlots()) return;

    if (isFroonzeReady()) {
      attachWishlistButtons();
      state.attempts = 0;
      return;
    }

    if (state.attempts >= maxAttempts) return;

    state.attempts += 1;
    window.clearTimeout(state.retryTimer);
    state.retryTimer = window.setTimeout(attachFroonzeCollectionWishlist, retryInterval);
  }

  function scheduleAttach() {
    state.attempts = 0;

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(attachFroonzeCollectionWishlist);
    } else {
      window.setTimeout(attachFroonzeCollectionWishlist, 0);
    }

    window.setTimeout(attachFroonzeCollectionWishlist, 500);
    window.setTimeout(attachFroonzeCollectionWishlist, 1500);
  }

  function handleHeroVariantChange(e) {
    var slot = document.querySelector('.product-hero__wishlist-slot');
    if (!slot) return;

    var btn = slot.querySelector('[data-frcp-variant-id]');
    if (!btn) return;

    slot.dataset.variantId = String(e.detail.variantId);
    btn.dataset.frcpVariantId = String(e.detail.variantId);

    if (window.frcp && window.frcp.wishlist &&
        typeof window.frcp.wishlist.updateWishlistButtonsStatus === 'function') {
      window.frcp.wishlist.updateWishlistButtonsStatus({
        handle: btn.dataset.frcpProductHandle
      });
    }
  }

  if (!state.bound) {
    state.bound = true;
    document.addEventListener('DOMContentLoaded', scheduleAttach);
    window.addEventListener('load', scheduleAttach);
    document.addEventListener('shopify:section:load', scheduleAttach);
    document.addEventListener('product-hero:variant-change', handleHeroVariantChange);
  }

  scheduleAttach();
})();
